import React, { useEffect, useState } from 'react';
import PanelShell from '../PanelShell';

const OrPanel = ({ nodeType, nodeId, data, onChange }) => {
  const [inputs, setInputs] = useState(data?.inputs || ['','']);
  useEffect(()=>{ setInputs(data?.inputs?.length ? data.inputs : ['','']); }, [data]);
  if (nodeType !== 'Or') return null;
  const update = (i,v)=>setInputs(s=>{ const n=[...s]; n[i]=v; return n; });
  const add=()=>setInputs(s=>[...s,'']); const del=(i)=>setInputs(s=>s.filter((_,idx)=>idx!==i));
  const save=()=> onChange({ label:'Or', inputs, Title:`OR(${inputs.filter(Boolean).join(', ')})` });
  return (
    <PanelShell title="OR" onSave={save} actions={<button onClick={add}>Girdi Ekle</button>}>
      {inputs.map((v,i)=>(
        <div key={i} style={{display:'flex',gap:8}}>
          <input value={v} onChange={e=>update(i,e.target.value)} />
          <button onClick={()=>del(i)}>Sil</button>
        </div>
      ))}
    </PanelShell>
  );
};
export default OrPanel;
